import { useEffect } from "react";
import { Link } from "react-router-dom";
import MarketingPageLayout from "../../components/marketing/MarketingPageLayout";
import { BRAND_DISPLAY_NAME, BRAND_NAME } from "../../constants/brand";
import "../../styles/auth.css";

const DELETION_EMAIL = "fastrecovery26@gmail.com";

export default function AccountDeletionPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content") || "";
    document.title = `Account Deletion | ${BRAND_NAME}`;
    if (meta) {
      meta.setAttribute(
        "content",
        "Request deletion of your FastSearch account and associated data from the app or by email."
      );
    }
    return () => {
      document.title = previousTitle;
      if (meta) meta.setAttribute("content", previousDescription);
    };
  }, []);

  return (
    <MarketingPageLayout wide>
      <header className="marketing-page__hero">
        <p className="terms-hero__eyebrow">Legal · FastSearch Website</p>
        <h1 className="marketing-page__title">FastSearch - Account Deletion</h1>
        <p className="marketing-page__lead">
          How to request deletion of your {BRAND_DISPLAY_NAME} account and associated data.
        </p>
      </header>

      <div className="marketing-panel">
        <p>
          You can request deletion of your FastSearch account and associated data in
          either of these ways:
        </p>

        <h2>Option 1: Inside the app</h2>
        <ol>
          <li>Open the FastSearch app and log in.</li>
          <li>Tap the menu (drawer) at the top left of the Home screen.</li>
          <li>Go to Settings &gt; Delete Account.</li>
          <li>Confirm the deletion.</li>
        </ol>

        <h2>Option 2: By email</h2>
        <p>
          Send an email to{" "}
          <a href={`mailto:${DELETION_EMAIL}`}>{DELETION_EMAIL}</a> from your
          registered email address with the subject &quot;Delete my account&quot;. Include
          your registered name and phone number. We will verify your request and delete
          your account within 7 days.
        </p>

        <h2>Data deleted:</h2>
        <p>Name, email address, phone number, and agent account details.</p>

        <h2>Data retained:</h2>
        <p>
          Records that we are required to keep by law or for legitimate business
          purposes (if any) are retained for up to 90 days and then permanently
          deleted.
        </p>
      </div>

      <div className="marketing-page__actions">
        <Link to="/" className="primary-page-btn">
          ← Back to Login
        </Link>
      </div>
    </MarketingPageLayout>
  );
}
